import React, { useEffect, useState } from 'react';
import body_type_img from '@Images/body-type.png';
import clsx from 'clsx';

const calculatePercentage = (value, normalRange, minValue, maxValue) => {
    const numericValue = parseFloat(value);
    if (numericValue < normalRange[0]) {
        return (numericValue / normalRange[0]) * 25;
    } else if (numericValue >= normalRange[0] && numericValue <= normalRange[1]) {
        return 25 + ((numericValue - normalRange[0]) / (normalRange[1] - normalRange[0])) * 50;
    } else {
        return 75 + ((numericValue - normalRange[1]) / (maxValue - normalRange[1])) * 25;
    }
};

const BodyTypeMapBox = ({ className, sourceData, pastData }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [pastPosition, setPastPosition] = useState(null);

    useEffect(
        () => {
            const calculatePosition = (bmi = 0, pbf = 0) => {
                const x = calculatePercentage(pbf, [18, 28], 0, 99);
                const y = calculatePercentage(bmi, [18.5, 24], 0, 99);
                return { x, y };
            };

            const { bmi, pbf } = sourceData;
            const { bmi: pastBmi, pbf: pastPbf } = pastData;

            setPosition(calculatePosition(bmi, pbf));
            if (bmi > 0 && pastBmi > 0) setPastPosition(calculatePosition(pastBmi, pastPbf));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [sourceData, pastData],
    );
    return (
        <div className={clsx('body-type-box', className)}>
            <div className={'body-type-box__wrap'}>
                <img className={'body-type-box__img'} src={body_type_img} alt={"inbody"}/>
                <div className={'body-type-box__map'}>
                    <div className="body-type-box__position" style={{ left: `${position.x}%`, bottom: `${position.y}%` }}></div>
                    {pastPosition && (
                        <div className="body-type-box__past-position" style={{ left: `${pastPosition.x}%`, bottom: `${pastPosition.y}%` }}></div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BodyTypeMapBox;
